import { render, staticRenderFns } from "./Decoration10.vue?vue&type=template&id=14657cfe&scoped=true"
import script from "./Decoration10.vue?vue&type=script&lang=js"
export * from "./Decoration10.vue?vue&type=script&lang=js"
import style0 from "./Decoration10.vue?vue&type=style&index=0&id=14657cfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14657cfe",
  null
  
)

export default component.exports